import { isEmpty } from "../utils/helpers";
import { ReturnStatus, RollReturnTxnType } from "../utils/types";

export const getTxnStatusLabel = (returnStatus, rollReturn) => {
  if (returnStatus === ReturnStatus.MISSED) return "Missing";
  if (returnStatus === ReturnStatus.CONFIRMED) return "Return Confirmed";
  if (returnStatus === ReturnStatus.RETURNED) return "Return Initiated";
  return returnStatus || (rollReturn?.txnType === RollReturnTxnType.MISSING ? "Missing" : "");
};

//** Merge roll rows (already carrying a returnStatus) with their RollReturn transaction for who/when info **//
export const buildTransactionRows = (rollInfoList = [], rollReturnList = []) => {
  return rollInfoList
    .filter(roll => !isEmpty(roll.rollReturnId))
    .map(roll => {
      const rollReturn = rollReturnList.find(rr => rr.id === roll.rollReturnId) || {};
      const isConfirmed = roll.returnStatus === ReturnStatus.CONFIRMED;
      return {
        ...roll,
        rollReturn,
        txnType: rollReturn.txnType,
        txnStatusLabel: getTxnStatusLabel(roll.returnStatus, rollReturn),
        txnQty: roll.availableWeight ?? roll.available,
        txnTime: isConfirmed ? rollReturn.modifiedAt : rollReturn.createdAt,
        initiatedBy: rollReturn.createdBy,
        initiatedOn: rollReturn.createdAt,
        confirmedBy: rollReturn.modifiedBy,
        confirmedOn: rollReturn.modifiedAt
      };
    })
    .map(({ parentId, ...e }) => e);
};

export const isKnitRoll = roll => !isEmpty(roll?.weight);
